import { render } from "./ShowBuzonSugerencias.vue?vue&type=template&id=07585b62&scoped=true"
import script from "./ShowBuzonSugerencias.vue?vue&type=script&lang=js"
export * from "./ShowBuzonSugerencias.vue?vue&type=script&lang=js"

import "./ShowBuzonSugerencias.vue?vue&type=style&index=0&id=07585b62&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07585b62"]])

export default __exports__